import React, { useState, useEffect } from 'react';

import { getServicios } from '../../services/ProductService';
import { addToCart } from '../../services/CartService';

import '../static/Home.css';
import '../static/Productos.css';
import '../static/Global.css';

function Productos() {
    const [servicios, setServicios] = useState([]);
    const [busqueda, setBusqueda] = useState('');
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchServs = async () => {
            try {
                const data = await getServicios();
                setServicios(Array.isArray(data) ? data : []);
                setLoading(false);
            } catch (error) {
                console.error("Error cargando servicios en Novatech:", error);
                setLoading(false);
            }
        };
        fetchServs();
    }, []);

    // Filtrado de servicios por búsqueda
    const serviciosFiltrados = servicios.filter(s => {
        if (!busqueda.trim()) return true;
        const term = busqueda.toLowerCase();
        return (s.nombre && s.nombre.toLowerCase().includes(term)) ||
               (s.descripcion && s.descripcion.toLowerCase().includes(term));
    });

    const handleAddToCart = (servicio) => {
        addToCart({
            ...servicio,
            productos_id: servicio.servicios_id,
            precio_venta: 0
        });
        alert(`${servicio.nombre} se añadió a tu lista de consulta`);
    };

    const handleCotizar = (servicio) => {
        const mensaje = `Hola NovaTech, deseo solicitar cotización sobre: "${servicio.nombre}".`;
        window.open(`https://wa.me/51906145083?text=${encodeURIComponent(mensaje)}`, '_blank');
    };

    return (
        <main className="main__section">
            <h1 className="main__title">Catálogo de Servicios</h1>

            <article className="container py-2">
                {/* BUSCADOR */}
                <div className="container mt-3">
                    <div className="search-container" style={{ maxWidth: '480px', margin: '0 auto' }}>
                        <input
                            type="text"
                            className="form-control"
                            placeholder="Buscar por nombre o descripción del servicio..."
                            value={busqueda}
                            onChange={(e) => setBusqueda(e.target.value)}
                        />
                    </div>
                </div>

                <section className="tab-content pt-4">
                    <div className="container py-4">
                        {loading ? (
                            <div className="loader-wrapper">
                                <div className="novatech-spinner"></div>
                                <span className="loader-text">Cargando Servicios...</span>
                            </div>
                        ) : serviciosFiltrados.length === 0 ? (
                            <div className="text-center py-5">
                                <p className="text-muted">No se encontraron servicios disponibles.</p>
                            </div>
                        ) : (
                            <div className="row row-cols-1 row-cols-sm-2 row-cols-lg-3 g-4">
                                {serviciosFiltrados.map((servicio) => (
                                    <div className="col" key={servicio.servicios_id}>
                                        <div className="product-card">
                                            {servicio.imagen ? (
                                                <img src={servicio.imagen} className="img-fluid" alt={servicio.nombre} />
                                            ) : (
                                                <div style={{ height: '200px', background: '#f8f9fa', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#999' }}>
                                                    <i className="fa-solid fa-briefcase fa-3x"></i>
                                                </div>
                                            )}

                                            <div className="product-info">
                                                <div className="name-row mt-2">
                                                    <span className="label">Servicio</span>
                                                    <span className="value fw-bold">{servicio.nombre}</span>
                                                </div>
                                                {/* Mostramos la descripción del servicio */}
                                                <p className="text-muted small mt-2" style={{ minHeight: '40px' }}>
                                                    {servicio.descripcion || 'Servicio tecnológico personalizado.'}
                                                </p>
                                            </div>

                                            <div className="d-flex justify-content-between align-items-center mt-3 pt-2 border-top">
                                                <button
                                                    className="btn btn-sm btn-outline-success rounded-pill px-3"
                                                    onClick={() => handleCotizar(servicio)}
                                                >
                                                    <i className="fa-brands fa-whatsapp me-1"></i> Cotizar
                                                </button>
                                                <button
                                                    className="buy-button"
                                                    onClick={() => handleAddToCart(servicio)}
                                                    title="Añadir a lista"
                                                >
                                                    <i className="fa-solid fa-plus"></i>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>
                </section>
            </article>
        </main>
    );
}

export default Productos;